export default {
  csvOrderLines: [],
  csvOrderLine: undefined,
};
